
import {defineComponent, ref} from 'vue'
export default defineComponent({
  name: 'PrintOgData',
  props: {
    og: null,
    ogLoading: null,
  },
})
